import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setUserFieldAction } from 'redux/auth/actions'
import {
  addInvestmentsToFavoritesAction,
  addInvestmentToFavoritesAction,
  removeInvestmentFromFavoritesAction
} from 'redux/dashboard/actions'
import PlatformFavorite from './PlatformFavorite'

const PlatformFavoriteContainer = props => {
  const {
    isLogged,
    userData: { token }
  } = useSelector(({ auth }) => auth)
  const { favoritePlatforms } = useSelector(({ dashboard }) => dashboard)

  const dispatch = useDispatch()

  const setUserField = useCallback(payload => dispatch(setUserFieldAction(payload)), [dispatch])
  const addInvestmentToFavorites = useCallback(payload => dispatch(addInvestmentToFavoritesAction(payload)), [dispatch])
  const addInvestmentsToFavorites = useCallback(
    payload => dispatch(addInvestmentsToFavoritesAction(payload)),
    [dispatch]
  )
  const removeInvestmentFromFavorites = useCallback(
    payload => dispatch(removeInvestmentFromFavoritesAction(payload)),
    [dispatch]
  )

  const updatedProps = {
    ...props,
    isLogged,
    favoritePlatforms,
    token,
    handleSetUserField: setUserField,
    handleAddInvestmentToFavorites: addInvestmentToFavorites,
    handleAddInvestmentsToFavorites: addInvestmentsToFavorites,
    handleRemoveInvestmentFromFavorites: removeInvestmentFromFavorites
  }

  return <PlatformFavorite {...updatedProps} />
}

export default PlatformFavoriteContainer
